.introSection {
  background-color: #f5f5f5;
  text-align: center;
  padding: 60px 0;
}

.mainContentSectionOuter {
  background-color: #e7f4f5;
}

.mainContentSection {
  width: 100%;
  max-width: 1100px;
}

.heading {
  line-height: 1.1em;
  font-size: 40px;
  color: #3caeb0;
  font-weight: bold;
  margin-bottom: 30px;
}

.link {
  color: #3caeb0;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.contentText {
  max-width: 900px;
  margin: 0 auto;
  line-height: 1.8em;
}

.paragraph {
  margin-bottom: 25px;
}

.form {
  padding: 48px 0;
}

@media (min-width: 768px) {
  .heading {
    font-size: 50px;
  }

  .form {
    padding: 96px 20px;
  }
}
